export const inputPaddingSizeClasses = {
    none: 'p-0',
    xs: 'p-0.5',
    sm: 'p-1',
    md: 'p-1.5',
    lg: 'p-2',
    xl: 'p-2.5',
    '2xl': 'p-3',
    '3xl': 'p-3.5',
    '4xl': 'p-4',
    '5xl': 'p-5',
    '6xl': 'p-6',
    '7xl': 'p-7',
    '8xl': 'p-8',
    '9xl': 'p-9',
    '10xl': 'p-10',
};
